'use strict';
import angular from 'angular';
import './widget.chatgpt.directives';

angular.module('widget.chatgpt', [
    'widget.chatgpt.directives'
]);